
import { Link } from "react-router-dom";

interface NavLinkProps {
  to: string;
  isActive: boolean;
  children: React.ReactNode;
  onClick?: () => void;
  mobile?: boolean;
  className?: string;
}

export const NavLink = ({ to, isActive, children, onClick, mobile = false, className = "" }: NavLinkProps) => {
  if (mobile) {
    return (
      <Link
        to={to}
        className={`text-neutral-600 py-2 ${
          isActive ? "font-bold text-brand-orange" : ""
        }`}
        onClick={onClick}
      >
        {children}
      </Link>
    );
  }

  return (
    <Link
      to={to}
      className={`relative text-neutral-600 transition-colors pb-1 ${
        isActive
          ? "font-bold bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-brand-orange after:absolute after:bottom-0 after:left-0 after:w-full after:h-1 after:bg-gradient-to-r after:from-brand-blue after:to-brand-orange"
          : "hover:text-brand-orange"
      } ${className}`}
    >
      {children}
    </Link>
  );
};
